import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import Markets from "@/pages/public/Markets";
import Platforms from "@/pages/public/Platforms";
import Accounts from "@/pages/public/Accounts";
import Conditions from "@/pages/public/Conditions";
import News from "@/pages/public/News";
import NewsDetail from "@/pages/public/NewsDetail";
import TradingIdeaDetail from "@/pages/public/TradingIdeaDetail";
import Education from "@/pages/public/Education";
import Faq from "@/pages/public/Faq";
import Promotions from "@/pages/public/Promotions";
import Contact from "@/pages/public/Contact";
import EconomicCalendar from "@/pages/public/EconomicCalendar";
import CustomPage from "@/pages/public/CustomPage";

import AdminLogin from "@/pages/admin/Login";
import RequireAuth from "@/components/admin/RequireAuth";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LinkManager from "@/pages/admin/LinkManager";
import Sections from "@/pages/admin/Sections";
import ContentManager from "@/pages/admin/ContentManager";
import Media from "@/pages/admin/Media";
import SeoManager from "@/pages/admin/SeoManager";
import SiteSettings from "@/pages/admin/SiteSettings";
import Users from "@/pages/admin/Users";
import Audit from "@/pages/admin/Audit";
import Contacts from "@/pages/admin/Contacts";
import MenuManager from "@/pages/admin/MenuManager";
import PagesManager from "@/pages/admin/PagesManager";

function App() {
  useEffect(() => {
    const s = document.getElementById("cb-splash");
    if (s) {
      s.style.opacity = "0";
      setTimeout(() => s.remove(), 400);
    }
  }, []);
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route element={<SitePublic />}>
              <Route path="/" element={<Home />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/platforms" element={<Platforms />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/conditions" element={<Conditions />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/trading-ideas/:id" element={<TradingIdeaDetail />} />
              <Route path="/education" element={<Education />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/economic-calendar" element={<EconomicCalendar />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/p/:slug" element={<CustomPage />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="links" element={<LinkManager />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="sections" element={<Sections />} />
              <Route path="pages" element={<PagesManager />} />
              <Route path="hero-slides" element={<ContentManager resource="hero_slides" />} />
              <Route path="news" element={<ContentManager resource="news" />} />
              <Route path="trading-ideas" element={<ContentManager resource="trading_ideas" />} />
              <Route path="education" element={<ContentManager resource="education" />} />
              <Route path="videos" element={<ContentManager resource="videos" />} />
              <Route path="events" element={<ContentManager resource="events" />} />
              <Route path="faq" element={<ContentManager resource="faq" />} />
              <Route path="promotions" element={<ContentManager resource="promotions" />} />
              <Route path="testimonials" element={<ContentManager resource="testimonials" />} />
              <Route path="media" element={<Media />} />
              <Route path="seo" element={<SeoManager />} />
              <Route path="settings" element={<SiteSettings />} />
              <Route path="users" element={<Users />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="audit" element={<Audit />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

function SitePublic() {
  return (
    <SiteProvider>
      <PublicLayout />
    </SiteProvider>
  );
}

export default App;
